import {
    SET_VISITOR_ID,
    SET_VISITOR_NAME,
    SET_VISITOR_EMAIL,
    SET_VISITOR_TOKEN,
    SET_VISITOR_SITE_ID,
    SET_VISITOR_URL,
    SET_VISITOR_DOMAIN
} from '../actions/types';

import {Map} from 'immutable';

function visitorReducer(state = Map(), action)
{
    switch (action.type)
    {
        case SET_VISITOR_ID:
            return setVisitorId(state, action);
        case SET_VISITOR_NAME:
            return setVisitorName(state, action);
        case SET_VISITOR_EMAIL:
            return setVisitorEmail(state, action);
        case SET_VISITOR_TOKEN:
            return setVisitorToken(state, action);
        case SET_VISITOR_URL:
            return setVisitorUrl(state, action);
        case SET_VISITOR_DOMAIN:
            return setVisitorDomain(state, action);
    }

    return state;
}

function setVisitorId(state, action)
{
    const id = action.payload;

    return state.set('id', id);
}

function setVisitorName(state, action)
{
    const name = action.payload;

    return state.set('name', name);
}

function setVisitorEmail(state, action)
{
    const email = action.payload;

    return state.set('email', email);
}

function setVisitorToken(state, action)
{
    const token = action.payload;

    return state.set('token', token);
}

function setVisitorUrl(state, action)
{
    const url = action.payload;

    return state.set('url', url);
}

function setVisitorDomain(state, action)
{
    const domain = action.payload;

    return state.set('domain', domain);
}

export default visitorReducer;


// WEBPACK FOOTER //
// ./common/js/redux/reducers/visitorReducer.js